import { normalizeTextString } from '../normalizeTextString';

export const calculatePrefixPath = (path: string): string => {
  const prefix = process.env.GATSBY_SITE_PATH_PREFIX;
  const normalizedPath = normalizeTextString(path, true);

  return prefix && !path.includes(`/${prefix}/`)
    ? `/${prefix}${normalizedPath}`
    : normalizedPath;
};
